var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    transform: "translate(-1320 -1011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701",
    transform: "translate(-359 312.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M1683.081,713.966a.422.422,0,0,1-.419-.448l.3-4.458a.413.413,0,0,1,.122-.269l6.482-6.481a.421.421,0,0,1,.594,0l8.16.16a.42.42,0,0,1,0,.594l-10.481,10.482a.414.414,0,0,1-.269.122l-4.458.3Zm4.458-.718h0Zm-3.752-3.975-.255,3.821,3.821-.255,10.072-10.073-7.565.434Z",
    transform: "translate(-0.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M1687.6,716.036a.418.418,0,0,1-.3-.123l-4.161-4.161a.42.42,0,0,1,.594-.594l4.161,4.161a.42.42,0,0,1-.3.717Z",
    transform: "translate(-0.162 -2.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M1691.666,719.841h-9.246a.42.42,0,1,1,0-.841h9.246a.42.42,0,1,1,0,.841Z",
    transform: "translate(0 -3.638)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M1342.5,1031h-21a1.5,1.5,0,0,1-1.5-1.5v-18a.5.5,0,0,1,.5-.5h23a.5.5,0,0,1,.5.5v18A1.5,1.5,0,0,1,1342.5,1031Zm-21.5-19v17.5a.5.5,0,0,0,.5.5h21a.5.5,0,0,0,.5-.5V1012Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M1343.5,1016h-23a.5.5,0,0,1,0-1h23a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1323 1013)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1325 1013)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1327 1013)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.9dd941179706ced68648933b53f683cc.svg";
export { ForwardRef as ReactComponent };